import Heading from '@shared/components/common/Heading';
import EditorContentDisplay from '@shared/components/editor/EditorContentDisplay';
import { useEffect } from 'react';
import { useStore } from '@shared/hooks/useStore';
import { observer } from 'mobx-react-lite';
import { SYSTEM_CONTENT_TYPE } from '@shared/configs/constants';

export default observer(function TermsOfServicePage() {
    const { settingSystemStore: { systemContent, getSystemContentByType } } = useStore();

    useEffect(() => {
        getSystemContentByType(SYSTEM_CONTENT_TYPE.TERMS_OF_SERVICE);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className='container min-h-screen py-12 space-y-10'>
            <Heading className='text-center'>利用規約</Heading>
            <EditorContentDisplay content={systemContent?.content || ''} />
        </div>
    );
});
